"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpHeader = void 0;
const tmpls_1 = require("./tmpls");
const App_1 = require("../App");
const ClassesTags_1 = require("../libs/ClassesTags");
class CmpHeader extends tmpls_1.CmpHeaderBase {
    constructor() {
        super();
        this._connectText = "";
        this.ctrls.btnMenu.onclick = () => this.ctrls.blockMobileNav.flipClass(ClassesTags_1.ClassesTags.Active);
        this.ctrls.btnConnect.disable();
        this._connectText = this.ctrls.btnConnect.text;
        this.ctrls.btnConnect.onclick = () => __awaiter(this, void 0, void 0, function* () {
            this.ctrls.btnConnect.disable();
            const result = yield App_1.App.chain.tryConnectAsync();
            this.ctrls.btnConnect.enable();
        });
    }
    initAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            App_1.App.chain.onChangeAccount.addHandler(() => __awaiter(this, void 0, void 0, function* () {
                yield this.refreshConnectionAsync();
            }));
            yield this.refreshConnectionAsync();
        });
    }
    refreshConnectionAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (App_1.App.chain.account) {
                const wallet = App_1.App.chain.account;
                this.ctrls.btnConnect.disable();
                this.ctrls.btnConnect.text = wallet.slice(0, 6) + "..." + wallet.slice(-4);
            }
            else {
                this.ctrls.btnConnect.enable();
                this.ctrls.btnConnect.text = this._connectText;
            }
            const chainId = yield App_1.App.chain.getChainIdAsync();
            if (chainId == App_1.App.chain.chainId) {
                this.ctrls.tagPLS.show();
                this.ctrls.tagWrongChain.hide();
            }
            else {
                this.ctrls.tagPLS.hide();
                this.ctrls.tagWrongChain.show();
            }
        });
    }
}
exports.CmpHeader = CmpHeader;
//# sourceMappingURL=CmpHeader.js.map